<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <info-card
            label="العضو الذي سيتم استبداله"
            :value="data.old_director_id  ? data.old_director_id.name : ''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="سبب التعديل"
            :value="data.switching_reason"
            />
        </b-col>
        <b-col cols="4" v-if='file'>
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                ملف محضر الجلسة الإدارية {{ data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label : ''  }} التي تمّ خلالها الموافقة على التعديل
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:file  } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col> 
        
        <b-col md="4" cols="12" v-else>
            <info-card
            label="رقم محضر الجلسة الإدارية التي تمّ خلالها الموافقة على التعديل"
            :value="data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label :''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="الاسم الكامل للعضو الجديد"
            :value="data.name"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="المؤهل العلمي"
            :value="data.qualification_id ? data.qualification_id.title : ''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="الصفة"
            :value="data.job_title_id ? data.job_title_id.name  : ''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="رقم الموبايل"
            :value="data.phone_number"
            />
        </b-col>   
        <b-col md="4" cols="12">
            <info-card label="تاريخ الميلاد"
            :value="data.dob"
            />
        </b-col>   
        <b-col md="4" cols="12">
            <info-card label="الرقم الوطني"
            :value="data.ID_number"
            />
        </b-col> 
        <b-col cols="4">
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                 نشرة الإستعلام
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:data.inquiry_bulletin_file } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col>           
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  import axios from "@axios";
  import router from "@/router";

  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton
    },
    data() {
        return {
            file: '',
        }
    },
    props: {
        data: Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
    watch: {
        data: {
        handler: async function(newVal, oldVal) {
            
            const currentRoute = router.currentRoute.path.includes('ministry')
            if(currentRoute){
                console.log("currentRoute" , currentRoute)
                await axios.get(`v2/ministry/ngo-meeting-minutes/${this.data.meeting_minute_id.id}`).then((res) => this.file=res.data.data.file);
            }
            else{
                this.file=null
            }
        },
        deep: true
        }
    },
  };
  </script>